import React from 'react';
import { Box, MessageModalLayout, Modal, SectionHelper, Text, TextButton, } from '@wix/design-system';
import { useExperiments } from '@wix/wix-experiments-react';
import { useTranslation } from '../../../hooks/use-translation';
import { useHttpClient } from '../../../hooks/use-http-client';
export function DeletePremiumModal({ appId, appName, handleClose, msId, }) {
    const { experiments } = useExperiments();
    const t = useTranslation();
    const [isLoading, setIsLoading] = React.useState(true);
    const [isPlanChangeEnabled, setIsPlanChangeEnabled] = React.useState(false);
    const httpClient = useHttpClient();
    function openPremiumSubscriptions() {
        const premiumSubscriptionsPageUrl = `https://manage.wix.com/dashboard/${msId}/manage-website/plans`;
        window.open(premiumSubscriptionsPageUrl, '_blank');
        handleClose();
    }
    function openPlanChange() {
        const planChangePageUrl = `https://manage.wix.com/upgrade/app/${appId}/plan-change?meta-site-id=${msId}&origin=manage_apps_bizmgr`;
        window.open(planChangePageUrl, '_blank');
    }
    React.useEffect(() => {
        httpClient
            .get(`https://${window.location.hostname}/_serverless/managed-installed-apps-serverless/plan-change?appId=${appId}&metaSiteId=${msId}`)
            .then((response) => response.data.isPlanChangeEnabled)
            .then(setIsPlanChangeEnabled)
            .finally(() => setIsLoading(false));
    }, [appId, msId]);
    if (isLoading) {
        return null;
    }
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(MessageModalLayout, { title: t('manage-apps.delete-premium.header', {
                name: appName,
            }).replace('&amp;', '&'), primaryButtonText: t('manage-apps.delete-premium.cta'), primaryButtonOnClick: openPremiumSubscriptions, secondaryButtonText: t('manage-apps.delete-premium.cancel'), secondaryButtonOnClick: handleClose, onCloseButtonClick: handleClose, dataHook: "delete-premium-app-modal" },
            React.createElement(Box, { direction: "vertical", gap: "24px", width: "552px" },
                React.createElement(Text, null,
                    t('manage-apps.delete-premium.line1'),
                    t('manage-apps.delete-premium.line2'),
                    React.createElement(Box, { inline: true, marginLeft: "6px" },
                        React.createElement(TextButton, { as: "a", href: t('manage-apps.delete-premium-learn-more-link'), target: "_blank", onClick: handleClose }, t('manage-apps.delete-premium.side-action')))),
                experiments.enabled('specs.app-market.TpaPlanDowngrade') &&
                    isPlanChangeEnabled ? (React.createElement(SectionHelper, { fullWidth: true, appearance: "standard", title: t('manage-apps.delete-modal.change-plan-title'), actionText: t('manage-apps.delete-modal.change-plan-button-label'), onAction: openPlanChange }, t('manage-apps.delete-modal.change-plan-description'))) : null))));
}
//# sourceMappingURL=delete-premium-modal.js.map